import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/pulse-ops-x7k2/support")({
  component: () => <Outlet />,
});
